import {
  AppBar,
  Divider,
  Drawer,
  IconButton,
  Toolbar,
  Tooltip,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import MenuIcon from '@material-ui/icons/Menu';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { withUsuario } from '../../contexts/UsuarioContext';
import Logout from '../Logout';
import DrawerList from './DrawerList';

const drawerWidth = 240;

const useStyles = makeStyles(
  (theme) => {
    return ({
      toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
        paddingTop: 10,
      },
      toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
      },
      appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      menuButton: {
        marginLeft: 12,
        marginRight: 36,
      },
      menuButtonHidden: {
        display: 'none',
      },
      menuItemBottom: {
        position: 'absolute',
        top: '100vh',
        transform: 'translateY(-100%)',
      },
      title: {
        flexGrow: 1,
        color: theme.palette.common.white,
        textDecoration: 'none',
      },
      link: {
        color: theme.palette.common.white,
        textDecoration: 'none'
      },
      drawerPaper: {
        position: 'relative',
        overflow: 'auto',
        height: '100%',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      },
    });
  });

function MenuAppBar(props) {

  const [open, setOpen] = useState(false);

  const classes = useStyles();

  return (
    <div>
      <AppBar
        position='absolute'
        className={classnames(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar disableGutters={!open} className={classes.toolbar}>
          <IconButton
            color='inherit'
            aria-label='Open drawer'
            onClick={() => setOpen(!open)}
            className={classnames(
              classes.menuButton,
              open && classes.menuButtonHidden,
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant='h6' color='inherit' noWrap className={classes.title}>
            <Link to={props.isUsuarioLogado ? '/dashboard' : '/'} className={classes.link}>
              TST-Saúde 3
            </Link>
          </Typography>
          {props.isUsuarioLogado && <Logout />}
        </Toolbar>
      </AppBar>
      <Drawer
        variant='permanent'
        classes={{
          paper: classnames(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={() => setOpen(!open)}>
            <ChevronLeft />
          </IconButton>
        </div>
        <Divider />
        <DrawerList />
        <Divider />
      </Drawer>
      <div className={classes.menuItemBottom}>
        <Tooltip title={!open ? 'Expandir barra lateral' : 'Recolher barra lateral'}>
          <IconButton onClick={() => setOpen(!open)}>
            {!open ? <ChevronRight /> : <ChevronLeft />}
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
}
export default withUsuario(MenuAppBar);
